import { Page } from "@customer/components/layout";
import { observer } from "mobx-react";
import React from "react";

export const AppLandingOutlet = observer(() => {
    return (
        <Page>
            <Page.Content>

            </Page.Content>
        </Page>
    )
});
